import {
    ColorVioletPrimary as bodyFatColor,
    ColorYellowPrimary as bmiColor,
    ColorGreenPrimary as vo2MaxColor,
    ColorBluePrimary as rhrColor
} from 'ui-connect/styles/default-theme';

export const FITNESS_AGE_FACTORS = {
    vigorousDaysAvg: {
        key: 'vigorousDaysAvg', // in API response
        translations_key: 'vigorousDaysAvg', // in web-translations
        hideWhenStale: true,
        reportColor: vo2MaxColor,
        directRecommendations: {
            titleKey: 'fitness_age_popup_to_help_achieve_goal',
            list: [
                'fitness_age_popup_direct_recommendation_text_vigorousDaysAvg_1_update',
                'fitness_age_popup_direct_recommendation_text_vigorousDaysAvg_2_update',
                'fitness_age_popup_direct_recommendation_text_vigorousDaysAvg_3_update'
            ]
        },
        educationalParagraphs: [
            'fitness_age_popup_educational_text_vigorousDaysAvg_1_update',
            'fitness_age_popup_educational_text_vigorousDaysAvg_2_update'
        ],
        bottomLinks: [
            {
                key: 'fitness_age_popup_link_bottom_vigorousDaysAvg_1_update',
                value: 'https://medlineplus.gov/howmuchexercisedoineed.html',
                isExternal: true
            },
            {
                key: 'fitness_age_popup_link_bottom_vigorousDaysAvg_2',
                value: `/training-plan`
            }
        ]
    },
    vigorousMinutesAvg: {
        key: 'vigorousMinutesAvg', // in API response
        translations_key: 'vigorousMinutesAvg', // in web-translations
        hideWhenStale: true,
        reportColor: vo2MaxColor,
        directRecommendations: {
            titleKey: 'fitness_age_popup_to_help_achieve_goal',
            list: [
                'fitness_age_popup_direct_recommendation_text_vigorousMinutesAvg_1',
                'fitness_age_popup_direct_recommendation_text_vigorousMinutesAvg_2',
                'fitness_age_popup_direct_recommendation_text_vigorousMinutesAvg_3'
            ]
        },
        educationalParagraphs: [
            'fitness_age_popup_educational_text_vigorousMinutesAvg_1',
            'fitness_age_popup_educational_text_vigorousMinutesAvg_2'
        ],
        bottomLinks: [
            {
                key: 'fitness_age_popup_link_bottom_vigorousMinutesAvg_1',
                value: 'https://www.mayoclinic.org/healthy-lifestyle/fitness/in-depth/exercise-intensity/art-20046887',
                isExternal: true
            },
            {
                key: 'fitness_age_popup_link_bottom_vigorousMinutesAvg_2',
                value: `/training-plan`
            }
        ]
    },
    rhr: {
        key: 'rhr',
        translations_key: 'rhr',
        reportColor: rhrColor,
        directRecommendations: {
            titleKey: 'fitness_age_popup_to_help_achieve_goal_rhr',
            list: [
                'fitness_age_popup_direct_recommendation_text_rhr_1',
                'fitness_age_popup_direct_recommendation_text_rhr_2',
                'fitness_age_popup_direct_recommendation_text_rhr_3',
                'fitness_age_popup_direct_recommendation_text_rhr_4'
            ]
        },
        middleLink: {
            key: 'fitness_age_popup_link_middle_rhr',
            value:
                'https://www.health.harvard.edu/blog/increase-in-resting-heart-rate-is-a-signal-worth-watching-201112214013',
            isExternal: true
        },
        educationalParagraphs: ['fitness_age_popup_educational_text_rhr_1'],
        bottomLinks: [
            {
                key: 'fitness_age_popup_link_bottom_rhr',
                value:
                    'https://www.heart.org/en/health-topics/high-blood-pressure/the-facts-about-high-blood-pressure/all-about-heart-rate-pulse',
                isExternal: true
            }
        ]
    },
    bodyFat: {
        key: 'bodyFat',
        translations_key: 'bodyFat',
        reportColor: bodyFatColor,
        directRecommendations: {
            titleKey: 'fitness_age_popup_to_help_achieve_goal',
            list: [
                'fitness_age_popup_direct_recommendation_text_bodyFat_1_update',
                'fitness_age_popup_direct_recommendation_text_bodyFat_2'
            ]
        },
        middleLink: {
            key: 'fitness_age_popup_link_middle_bodyFat',
            value:
                'https://www.acefitness.org/education-and-resources/lifestyle/blog/112/what-are-the-guidelines-for-percentage-of-body-fat-loss/',
            isExternal: true
        },
        educationalParagraphs: [
            'fitness_age_popup_educational_text_bodyFat_1',
            'fitness_age_popup_educational_text_bodyFat_2'
        ]
    },
    bmi: {
        key: 'bmi',
        translations_key: 'bmi',
        reportColor: bmiColor,
        directRecommendations: {
            titleKey: 'fitness_age_popup_to_help_achieve_goal',
            list: ['fitness_age_popup_direct_recommendation_text_bmi_1_update']
        },
        educationalParagraphs: [
            'fitness_age_popup_educational_text_bmi_1',
            'fitness_age_popup_educational_text_bmi_2',
            'fitness_age_popup_educational_text_bmi_3'
        ],
        middleLink: {
            key: 'fitness_age_popup_link_middle_bmi',
            value: 'https://www.mayoclinic.org/healthy-lifestyle/fitness/in-depth/exercise-intensity/art-20046887',
            isExternal: true
        },
        bottomLinks: [
            {
                key: 'fitness_age_popup_link_bottom_bmi',
                value: 'https://www.who.int/news-room/fact-sheets/detail/obesity-and-overweight',
                isExternal: true
            },
            {
                key: 'fitness_age_popup_add_weight',
                value: null
            }
        ]
    }
};

export const FITNESS_AGE_FACTOR_TYPES = {
    recommendation: 'RECOMMENDATION',
    onTarget: 'ON_TARGET',
    stale: 'STALE',
    missingUserSettings: 'MISSING_USER_SETTINGS'
};

export const FITNESS_AGE_LAST_DECREASED_DATE_PREFERENCE = 'FitnessAge.LastDecreasedDate';

export const FITNESS_AGE_INVALID_REASONS = {
    USER_EMPTY_AGE: 'USER_EMPTY_AGE',
    USER_UNDER_AGE: 'USER_UNDER_AGE',
    USER_OVER_AGE: 'USER_OVER_AGE',
    USER_PREGNANT: 'USER_PREGNANT'
};
